<template>
    <LeftSidebar :open="collectionSidebarOpen" :width="650" :updateSidebar="updateCollectionSidebar" 
        :dark=true style="z-index: 32 !important" v-if="mapReady"
        :actionIcon="'help'"
        :actionFunction="showHelp"
        :actionIcon2="isSuperUser ? 'person' : null"
        :actionFunction2="function () { showImpersonate = true; }"
        actionTooltip2="Be Another User" 
        :loading="rcLoading"       
        >
        
    <div slot="sbTitle">
        <v-layout row align-center justify-space-around fill-height>
        <v-flex>Room Collections</v-flex>

        </v-layout>
    </div> 

    <div slot="sbContent" class="pl-4 pr-4">        
        <RoomPreview v-if="!$vuetify.breakpoint.xsOnly && selectedRoom" />
        <div v-else class="mt-5"></div>
        <RoomCollections v-if="collectionSidebarOpen"
            :showImpersonate="showImpersonate" 
            v-on:updateShowImpersonate="(value) => { showImpersonate=value }"
        />           
    </div>
    
  </LeftSidebar>
</template>

<script>
    import { mapMutations, mapState } from 'vuex'
    import LeftSidebar from './LeftSidebar'
    import RoomPreview from './RoomCollector/RoomPreview'
    import RoomCollections from './RoomCollector/RoomCollections'
    


    let CollectionSidebar = {

        data() {
          return {
            showImpersonate: false,
          }
        },

        components: { LeftSidebar, RoomCollections, RoomPreview,  },

        computed: {
            ...mapState({
                collectionSidebarOpen:  state => state.ui.collectionSidebarOpen,
                mapReady: state => state.mapFunctions.mapReady,
                selectedRoom: state => state.space.selectedRoom,
                isSuperUser: state => state.user.isSuperUser,
                rcLoading: state => state.roomCollections.rcLoading,
            }),
        },

        methods: {
            ...mapMutations([   'updateCollectionSidebar', 'setShowHelpRoomCollections' ]),
            
            showHelp: function () {
                this.setShowHelpRoomCollections(true)
            },
        }

    }

    export default CollectionSidebar
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/CollectionSidebar.vue